export default __webpack_public_path__ + "static/scablands-984fdf9b54bbb5e42debb5edd63ae182.jpeg";